const facettedSearchWidget = require('../../_utilities/facettedsearchwidget');

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'amateurs',
    component: 'amateurs',
    reducer: reducer(),
  })
    .then(facettedSearchWidget('amateurs'))
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/amateurs/amateurs.js